import React from "react";
import {TextField} from "@material-ui/core";
import {FieldProps, getIn} from 'formik';
import {useTranslation} from "react-i18next";

type TextFieldProps = {
    caption: string,
    readOnly?: boolean,
    required?: boolean,
}

const TextFieldWithErrorMessage: React.FC<FieldProps & TextFieldProps> = ({field, readOnly, caption, required, ...props}) => {
    const {t} = useTranslation();

    const error = getIn(props.form.errors, field.name);
    const touch = getIn(props.form.touched, field.name);
    const errorText = ((props.form.isSubmitting && error) || (touch && error)) ? error : null;

    return <TextField disabled={readOnly} {...field} {...props}
                      label={t(caption)}
                      required={required}
                      fullWidth
                      margin="normal" error={!!errorText}
                      helperText={t(errorText)}
    />
};

export default TextFieldWithErrorMessage;